module.exports = __webpack_public_path__ + "media/images/star-dfe17ab6d326068bb49ae048a266aa35.svg";